"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "authCtrl",
    function (
      $scope,
      $rootScope,
      $state,
      $http,
      $filter,
      $localStorage,
      Auth,
      settings,
      apiSettings,
      permissionService,
      MessageService
    ) {
      var vm = this;

      var $translate = $filter("translate");

      $rootScope.laddaLoading = false;

      $localStorage.$reset();

      vm.projectModule = config.projectModule;

      switch (vm.projectModule) {
        case 'SWFlow':
          $(".auth-img").prepend(
            '<img src="/images/logo-sherwin-williams-swflow.png" alt="SWFLOW" />'
          );
          $(".powered-img").prepend(
            '<img src="/Images/img-powered.svg" alt="Powered by Astéria" />'
          );
          break;
        case 'Colors':
          $("body").addClass("a-sua-cor");
          $(".auth-img").prepend(
            '<img src="/images/logo-sw-colorsnap.png" alt="A Sua Cor" />'
          );
          $(".powered-img").prepend(
            '<img src="/Images/img-asuacor-powered.svg" alt="Powered by Astéria" />'
          );
          break;
      }

      vm.authenticate = function () {
        vm.auth_error = null;
        $rootScope.laddaLoading = true;

        Auth.signin({
          email: vm.model.email,
          password: vm.model.password,
          projectModule: vm.projectModule
        }).$promise.then(
          function (response) {
            $localStorage.authorizationData = response;

            settings.setUser(response.user);
            // A sua cor default page

            settings.clearSessionFilters();

            if (settings.redirectTo.state) {
              $state.go(
                settings.redirectTo.state.name,
                settings.redirectTo.params
              );
              settings.clearRedirect();
            } else {
              switch (vm.projectModule) {
                case 'SWFlow':
                  if (settings.permissions.includes("ManagePromotionRequests")) {
                    $state.go("main.dashboard");
                    return;
                  } else if (settings.permissions.includes("BonusesAndSponsorshipsAccess")) {
                    $state.go("main.bonusesandsponsorship");
                    return;
                  }

                  $rootScope.laddaLoading = false;
                  vm.auth_error = "Falha ao redirecionar para o módulo correto!";

                  return;

                case 'Colors':
                  if (
                    settings.permissions.includes("ManageColorsRequests")
                  ) {
                    $state.go("main.colorrequest");
                    return;
                  }

                  $rootScope.laddaLoading = false;
                  vm.auth_error = "Falha ao redirecionar para o módulo correto!";

                  return;

                default:
                  $rootScope.laddaLoading = false;
                  vm.auth_error = "Desculpe, houve uma falha! Você pode tentar limpar os dados do seu navegador e tentar novamente.";
              }
            }
          },
          function (response) {
            $rootScope.laddaLoading = false;
            vm.auth_error = response.data || "Email e/ou senha inválidos!";
          }
        );
      };
    }
  );
